module.exports = __webpack_public_path__ + "static/media/fullscreen_close.d521f6af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fullscreen_close.svg
// module id = 998
// module chunks = 0